import { RootState } from '../../Store';
import { useSelector } from 'react-redux';

const useGetToggledPropertyCategories = (): string[] =>
    useSelector<RootState, string[]>(state => state.filter.toggledPropertyCategories);

export default useGetToggledPropertyCategories;
